module.exports = __webpack_public_path__ + "static/media/franchise-04.404ce327.png";